import { searchSuggestionClick } from 'store/homePage/homePageActions';
import { createSearchSuggestionClickEvent } from '../eventCreators';
import { createSearchSuggestionClickEventPayload } from '../dataHelpers/createSearchSuggestionClickEventPayload';

const emitSearchSuggestionClickEvent = ({ payload }) => {
  return createSearchSuggestionClickEvent(
    createSearchSuggestionClickEventPayload({
      componentVariant: payload.componentVariant,
      itemId: payload.itemId,
      itemName: payload.itemName,
      itemText: payload.itemText,
      index: payload.index,
      url: payload.url,
      count: payload.count,
      searchRecent: payload.searchRecent,
      viewMode: payload.viewMode,
    }),
  );
};

// eslint-disable-next-line
// @ts-ignore
export default { [searchSuggestionClick]: emitSearchSuggestionClickEvent };
